import type { View } from "@-/com.npmjs.react-native";
import { publishWelcomeGalaxyEntryCard } from "@-/dev.improve.haniverse.routes.nav.app.auth.welcome-galaxy-entry";

/** The card shell's `rounded-xs` corners (2pt). */
const LEARN_SUMMARY_CARD_RADIUS = 2;

/**
 * Reports where the Learn summary card is on screen, so that signing in from the welcome galaxy
 * can turn the galaxy into exactly this card (`WelcomeGalaxyEntryHost`). Call it from the card's
 * `onLayout` with the view that frames the card (the loaded card's and its first-paint
 * fallback's alike, since the entry may land on either). A card that has gone leaves its last
 * frame standing: the next card is in the same place, and the entry may still be morphing.
 */
export function publishLearnSummaryFlashcardFrame(view: View | null): void {
  view?.measureInWindow((x, y, width, height) => {
    if (width > 0 && height > 0) {
      publishWelcomeGalaxyEntryCard({ height, radius: LEARN_SUMMARY_CARD_RADIUS, width, x, y });
    }
  });
}
